(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-partner/assets/react/pages/company-details/components/company-details-form/components/contact-person.js') >= 0) return;  svs.modules.push('/modules/ticket-partner/assets/react/pages/company-details/components/company-details-form/components/contact-person.js');
"use strict";

const _React = React,
  useContext = _React.useContext,
  Fragment = _React.Fragment;
const HEADER = svs.ticket_partner.companyDetails.constants.TEXTS.CONTACT_PERSON.HEADER;
const _svs$ticket_partner$s = svs.ticket_partner.sharedComponents.input,
  OrgNrInput = _svs$ticket_partner$s.OrgNrInput,
  CompanyNameInput = _svs$ticket_partner$s.CompanyNameInput,
  ContactInput = _svs$ticket_partner$s.ContactInput,
  EmailInput = _svs$ticket_partner$s.EmailInput,
  PhoneNrInput = _svs$ticket_partner$s.PhoneNrInput,
  CellPhoneNrInput = _svs$ticket_partner$s.CellPhoneNrInput;
const CONTACT_PERSON = svs.ticket_partner.sharedComponents.input.constants.names.CONTACT_PERSON;
const UPDATE_CONTACT_PERSON = svs.ticket_partner.companyDetails.constants.actions.UPDATE_CONTACT_PERSON;
const ContactDetails = _ref => {
  let state = _ref.state;
  return Object.values(state).map((val, i) => React.createElement("div", {
    key: _.uniqueId(i)
  }, val));
};
const ContactPerson = () => {
  const _useContext = useContext(svs.ticket_partner.CompanyDetailsContext),
    state = _useContext.state,
    dispatch = _useContext.dispatch;
  const _state$companyDetails = state.companyDetails,
    contactPerson = _state$companyDetails.contactPerson,
    organizationNumber = _state$companyDetails.organizationNumber,
    companyName = _state$companyDetails.companyName,
    phone = _state$companyDetails.phone,
    cellPhone = _state$companyDetails.cellPhone,
    eMail = _state$companyDetails.eMail;
  const handleChange = e => {
    dispatch({
      type: UPDATE_CONTACT_PERSON,
      payload: {
        field: e.target.id,
        value: e.target.value
      }
    });
  };
  return React.createElement(Fragment, null, React.createElement("h2", null, HEADER), state.companyDetails.edit ? React.createElement(Fragment, null, React.createElement(CompanyNameInput, {
    disabled: true,
    handleChange: handleChange,
    isLessSpace: true,
    state: state.companyDetails
  }), React.createElement(OrgNrInput, {
    disabled: true,
    handleChange: handleChange,
    isLessSpace: true,
    state: state.companyDetails
  }), React.createElement(ContactInput, {
    handleChange: handleChange,
    isLessSpace: true,
    state: state.companyDetails,
    stateField: CONTACT_PERSON
  }), React.createElement(EmailInput, {
    handleChange: handleChange,
    isLessSpace: true,
    state: state.companyDetails
  }), React.createElement(CellPhoneNrInput, {
    handleChange: handleChange,
    isLessSpace: true,
    state: state.companyDetails
  }), React.createElement(PhoneNrInput, {
    handleChange: handleChange,
    isLessSpace: true,
    state: state.companyDetails
  })) : React.createElement(ContactDetails, {
    state: [companyName, organizationNumber, contactPerson, eMail, phone, cellPhone]
  }));
};
svs.ticket_partner.companyDetails.components.companyDetailsForm.components.ContactPerson = ContactPerson;

 })(window);